import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { hasPermission } from '../utils/role';

/**
 * Oculta el elemento cuando el usuario no cuenta con el permiso indicado.
 * Uso: <button appHasPermission module="users">...</button>
 * `module` es obligatorio; `subModule` y `action` son opcionales.
 */
@Directive({
	selector: '[appHasPermission]'
})
export class HasPermissionDirective implements OnInit {
	@Input() module!: string;
	@Input() subModule: string | undefined = undefined;
	@Input() action: string | undefined = undefined;

	constructor(private el: ElementRef) {}

	ngOnInit(): void {
		if (!this.module) {
			throw new Error('The appHasPermission directive requires a module input.');
		}

		const access = hasPermission(this.module, this.subModule, this.action);
		if (!access) {
			this.el.nativeElement.remove();
		}
	}
}